
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { uiStore } from "@/store/store-accessor";
@Component({})
export default class RegeneratingCacheProgress extends Vue {
  initialTotalPostIdsLength: null | number = null;

  get isCacheRegenerating() {
    return !!uiStore.idsOfPostsToRegenerateCache;
  }

  get progress() {
    if (!uiStore.idsOfPostsToRegenerateCache) {
      return 0;
    }

    const postIdsLength = uiStore.idsOfPostsToRegenerateCache.length;

    // it can be 0 because it finished, or because it's loading all posts
    if (postIdsLength === 0) {
      this.initialTotalPostIdsLength = null;

      return 0;
    } else if (!this.initialTotalPostIdsLength) {
      this.initialTotalPostIdsLength = postIdsLength;
    }

    // id initially there are 5 posts and we're down to 3 posts, that's 60% progress
    return (
      100 - postIdsLength * Math.round(100 / this.initialTotalPostIdsLength)
    );
  }
}
